
      import { ConsoleLogger, checkLoafSupport } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const firstPartyBtn = document.getElementById("firstPartyBtn");
      const simulateAnalyticsBtn = document.getElementById("simulateAnalyticsBtn");
      const simulateAdsBtn = document.getElementById("simulateAdsBtn");
      const clearBtn = document.getElementById("clearBtn");

      checkLoafSupport();

      // Contadores
      let firstPartyFrames = 0;
      let firstPartyTime = 0;
      let thirdPartyFrames = 0;
      let thirdPartyTime = 0;

      // Observer de LoAF
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          analyzeFrame(entry);
        }
      });

      try {
        observer.observe({
          type: "long-animation-frame",
          buffered: true,
        });
      } catch (e) {
        logger.error("LoAF no soportado");
      }

      // Helper para determinar si es third-party
      function isThirdPartyScript(script) {
        if (!script.sourceURL) return false;

        const url = new URL(script.sourceURL);

        // Considerar third-party si:
        // 1. Origin diferente
        if (url.origin !== location.origin) return true;

        // 2. Path que simula third-party (para el demo)
        if (url.pathname.includes("/third-party-scripts/")) return true;

        return false;
      }

      function analyzeFrame(entry) {
        logger.log("");
        logger.log("═══════════════════════════════════════════════════");
        logger.log("📊 FRAME LENTO DETECTADO");
        logger.log("═══════════════════════════════════════════════════");
        logger.log("");

        logger.log(`Duration: ${entry.duration.toFixed(2)}ms`);
        logger.log(`Scripts: ${entry.scripts.length}`);
        logger.log("");

        let hasThirdParty = false;

        entry.scripts.forEach((script, i) => {
          const isThirdParty = isThirdPartyScript(script);

          if (isThirdParty) {
            hasThirdParty = true;

            const url = new URL(script.sourceURL);
            // Para el demo, extraer el nombre del archivo
            const filename = url.pathname.split("/").pop();

            logger.warn(`🔴 THIRD-PARTY Script #${i + 1}:`);
            logger.warn(`   File: ${filename}`);
            logger.warn(`   Function: ${script.sourceFunctionName || "(anónima)"}`);
            logger.warn(`   Duration: ${script.duration.toFixed(2)}ms`);

            const category = categorizeThirdParty(filename);
            logger.warn(`   Category: ${category.type} (${category.vendor})`);

            if (script.forcedStyleAndLayoutDuration > 10) {
              logger.warn(
                `   Forced layout: ${script.forcedStyleAndLayoutDuration.toFixed(2)}ms ⚠️`,
              );
            }

            logger.log("");

            // Actualizar contadores
            thirdPartyFrames++;
            thirdPartyTime += script.duration;
          } else {
            logger.log(`🟢 First-party Script #${i + 1}:`);
            logger.log(`   Function: ${script.sourceFunctionName || "(anónima)"}`);
            logger.log(`   Duration: ${script.duration.toFixed(2)}ms`);
            logger.log("");

            // Actualizar contadores
            firstPartyFrames++;
            firstPartyTime += script.duration;
          }
        });

        // Diagnóstico
        if (hasThirdParty) {
          logger.warn("💡 RECOMENDACIÓN:");
          logger.warn("   Considera lazy-loading de scripts third-party");
          logger.warn("   o cargarlos después de la interacción del usuario");
          logger.log("");
        }

        logger.log("═══════════════════════════════════════════════════");
        logger.log("");

        updateSummary();
      }

      function categorizeThirdParty(identifier) {
        // Puede ser hostname o filename
        const id = identifier.toLowerCase();

        if (
          id.includes("analytics") ||
          id.includes("google-analytics") ||
          id.includes("googletagmanager")
        ) {
          return { type: "Analytics", vendor: "Analytics Provider" };
        }

        if (id.includes("ads") || id.includes("doubleclick") || id.includes("googlesyndication")) {
          return { type: "Ads", vendor: "Ad Network" };
        }

        if (id.includes("facebook") || id.includes("connect.facebook")) {
          return { type: "Social", vendor: "Facebook" };
        }

        return { type: "Unknown", vendor: "Third-party" };
      }

      function updateSummary() {
        document.getElementById("firstPartyCount").textContent = `${firstPartyFrames} frames`;
        document.getElementById("firstPartyTime").textContent =
          `${firstPartyTime.toFixed(0)}ms total`;

        document.getElementById("thirdPartyCount").textContent = `${thirdPartyFrames} frames`;
        document.getElementById("thirdPartyTime").textContent =
          `${thirdPartyTime.toFixed(0)}ms total`;

        const totalTime = firstPartyTime + thirdPartyTime;
        const ratio = totalTime > 0 ? (thirdPartyTime / totalTime) * 100 : 0;

        const ratioElement = document.getElementById("thirdPartyRatio");
        ratioElement.textContent = `${ratio.toFixed(1)}%`;

        // Color según ratio
        if (ratio > 50) {
          ratioElement.style.color = "var(--color-danger)";
        } else if (ratio > 25) {
          ratioElement.style.color = "var(--color-warning)";
        } else {
          ratioElement.style.color = "var(--color-success)";
        }
      }

      // Botón first-party
      firstPartyBtn.addEventListener("click", function handleFirstPartyClick() {
        logger.log("🟢 Cargando script first-party...");

        const script = document.createElement("script");
        script.src = "/examples/scripts/heavy-computation.js";
        script.async = true;

        script.onload = () => {
          logger.log("✅ Script cargado y ejecutado");
          logger.log("⏳ Esperando análisis de LoAF...");
          logger.log("");
        };

        script.onerror = () => {
          logger.error("❌ Error cargando script");
        };

        document.head.appendChild(script);
      });

      // Simular analytics third-party
      simulateAnalyticsBtn.addEventListener("click", function simulateAnalytics() {
        logger.log("🟡 Cargando script de analytics...");

        // Cargar script externo (simulando third-party)
        // El script se auto-ejecuta al cargar (patrón típico third-party)
        const script = document.createElement("script");
        script.src = "/examples/third-party-scripts/analytics.js";
        script.async = true;

        script.onload = () => {
          logger.log("✅ Script cargado y auto-ejecutado");
          logger.log("⏳ Esperando análisis de LoAF...");
          logger.log("");
        };

        script.onerror = () => {
          logger.error("❌ Error cargando script de analytics");
        };

        document.head.appendChild(script);
      });

      // Simular ads third-party
      simulateAdsBtn.addEventListener("click", function simulateAds() {
        logger.log("🔴 Cargando script de ads (muy pesado)...");

        // Cargar script externo (simulando third-party)
        // El script se auto-ejecuta al cargar (patrón típico third-party)
        const script = document.createElement("script");
        script.src = "/examples/third-party-scripts/ads.js";
        script.async = true;

        script.onload = () => {
          logger.log("✅ Script cargado y auto-ejecutado");
          logger.log("⏳ Esperando análisis de LoAF...");
          logger.log("");
        };

        script.onerror = () => {
          logger.error("❌ Error cargando script de ads");
        };

        document.head.appendChild(script);
      });

      // Limpiar
      clearBtn.addEventListener("click", () => {
        logger.clear();
        firstPartyFrames = 0;
        firstPartyTime = 0;
        thirdPartyFrames = 0;
        thirdPartyTime = 0;
        updateSummary();
        showInitialMessage();
      });

      function showInitialMessage() {
        logger.log("👋 Haz clic en los botones para cargar diferentes scripts");
        logger.log("📌 Observa cómo LoAF identifica first-party vs third-party");
        logger.log("🌐 Revisa la pestaña Network en DevTools para ver las peticiones");
        logger.log("");
      }

      // Mensaje inicial
      showInitialMessage();
    